export default __webpack_public_path__ + "static/media/weapons.7d0f8222.png";